import { jsonCopy } from "./helper";
import { nanoid } from "nanoid";
import store from "../stores/StoreRoot";

function processHostedTableChanges(changes) {
  // go through the changes and update the ar_id if it's missing
  for (const change of changes) {
    const dataItem = change?.dataItem;
    if (dataItem && !dataItem?.ar_id) {
      const arId = nanoid(8);
      dataItem.ar_id = arId;
      // const sourceIndex = change?.sourceIndex;
    }
  }
  return changes;
}

export async function sendHostedTableRequest(
  type,
  options,
  tableItem,
  showSpinnerProc
) {
  const basicApiUrl = store.tables.basicApiUrl;
  console.log("INFO sendRequest", type, options);

  // if (tableItem.sourceType === "automation") {
  //   let data = store.tables.getTableItemData(tableItem);
  //   return data;
  // }

  if (showSpinnerProc) showSpinnerProc(true);
  try {
    const tableId = tableItem?.id;
    const tableToken = tableItem?.data?.auth?.token;
    const tokenString = "&token=" + tableToken;
    let apiUrl = basicApiUrl + "table?id=" + tableId + tokenString;
    if (type === "batch") {
      let changes = jsonCopy(options.body);
      changes = processHostedTableChanges(changes);
      options.body = changes;
    }

    options.method = options.method || "POST";
    options.headers = { "Content-Type": "application/json; charset=utf-8" };
    if (options.body) {
      options.body = JSON.stringify(options.body);
    }
    // await waitMilliSeconds(2000);

    return fetch(apiUrl, options)
      .then((resp) => {
        if (resp.ok) {
          if (showSpinnerProc) showSpinnerProc(false);
          return resp.json();
        } else {
          if (showSpinnerProc) showSpinnerProc(false);
          throw resp.statusText;
        }
      })
      .catch((err) => {
      });
  } catch (error) {
    console.log("ERROR sending request", error);
  } finally {
  }
}
